/** Maps InsightMaster itemType to RBAC module_key (must match backend). */
export const INSIGHT_TYPE_TO_MODULE = {
  CATEGORY: 'CATEGORIES',
  SUB_CATEGORY: 'SUB_CATEGORIES',
  CONCEPT: 'CONCEPTS',
  FEEDER: 'FEEDERS',
  COLOR: 'COLORS',
};

export function moduleForInsightType(itemType) {
  return INSIGHT_TYPE_TO_MODULE[itemType] || null;
}
